<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-user-create *ngIf="open.create" (close)="onCloseCreate()"></pg-user-create>

<pg-user-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-user-update>

<div class="card">
  <ami-head [settings]="settingsAmiHead"> </ami-head>
  <ami-table
    [settings]="table.settings"
    [data]="table.data"
    (action)="onReciveAction($event)"
  ></ami-table>
</div>
